import { mapState } from 'vuex';

// @vue/component
export default {
  props: {
    inFooter: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      contactSupportLink: state => state.config.contactSupportLink,
      knowledgeBaseLink: state => state.config.knowledgeBaseLink,
    }),
    helpMenuItems() {
      const vm = this;
      return [{
        icon: 'far fa-life-ring',
        label: `Knowledge base`,
        action: () => window.open(vm.knowledgeBaseLink, '_blank'),
      }, {
        icon: 'fas fa-bullhorn',
        label: 'Feedback',
        action: () => vm.$emit('show-feedback'),
      }, {
        icon: 'far fa-comments',
        label: 'Contact support',
        action: () => window.open(vm.contactSupportLink, '_blank'),
      }];
    },
  },
};
